import DemographyForm from "./Components/DemographyForm";

export default DemographyForm;
